export default "__VITE_ASSET__8WnqzgCO__"